// extracted by mini-css-extract-plugin
export default {"button":"WhatsAppButton_button__8gVxU","icon":"WhatsAppButton_icon__8RMOn"};